const STATUS = {
  generating: ["Gerando...", "bg-amber-500/15 text-amber-300 border-amber-500/40"],
  pending: ["Aguardando aprovação", "bg-sky-500/15 text-sky-300 border-sky-500/40"],
  approved: ["Aprovado, agendado", "bg-emerald-500/15 text-emerald-300 border-emerald-500/40"],
  publishing: ["Publicando...", "bg-amber-500/15 text-amber-300 border-amber-500/40"],
  published: ["Publicado", "bg-emerald-500/20 text-emerald-300 border-emerald-500/50"],
  failed: ["Falhou", "bg-red-500/15 text-red-300 border-red-500/40"],
  rejected: ["Rejeitado", "bg-zinc-500/15 text-zinc-300 border-zinc-500/40"],
  missed: ["Horário perdido", "bg-orange-500/15 text-orange-300 border-orange-500/40"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = STATUS[status] || [status, ""];
  return <span className={`dz-mono text-[11px] uppercase tracking-widest px-2 py-1 border ${cls}`} data-testid={testId}>{label}</span>;
};

const RESULT = { success: ["Postado", "text-emerald-400"], error: ["Erro", "text-red-400"], not_connected: ["Não conectado", "text-zinc-500"] };

export const FB_GROUP_URL = "https://www.facebook.com/groups/dayzbrasilxbox";

export const ResultLine = ({ network, label, result }) => {
  const [txt, cls] = RESULT[result.status] || [result.status, ""];
  const fbLink = network === "facebook" && result.status === "success" && result.id;
  return (
    <p className="text-xs" data-testid={`result-${network}`}>
      <span className="text-zinc-300">{label}:</span> <span className={cls}>{txt}</span>
      {result.error && <span className="text-zinc-500"> ({result.error})</span>}
      {fbLink && (
        <>
          {" "}·{" "}
          <a href={`https://www.facebook.com/${result.id}`} target="_blank" rel="noopener noreferrer" className="underline text-sky-300" data-testid="facebook-post-link">abrir post</a>
          {" "}·{" "}
          <a href={FB_GROUP_URL} target="_blank" rel="noopener noreferrer" className="underline text-sky-300" data-testid="facebook-group-link">compartilhar no grupo</a>
        </>
      )}
    </p>
  );
};
